<template>
  <el-drawer
    size="1600px"
    :visible.sync="dialogVisible"
    :with-header="false"
    :destroy-on-close="true"
    :wrapperClosable="false"
    @close="handleClose"
  >
    <div class="drawer">
      <div class="drawer-header">
        <div class="drawer-header-text">编辑人群方案</div>
        <div class="drawer-header-close">
          <img
            :src="globalCdn + '/images/remake/close.png'"
            @click="handleClose"
          />
        </div>
      </div>
      <div class="drawer-content">
        <el-tabs
          v-model="activeTab"
          :class="[
            { 'global-single-tab': tabs.length == 1 },
            'edit-group-tabs',
          ]"
          :addable="addable"
          :closable="tabs.length > 1"
          @edit="handleTabsEdit"
        >
          <el-tab-pane
            v-for="(item, index) in tabs"
            :key="item.value"
            :label="item.name"
            :name="item.value"
          >
            <custimerdetail-new
              class="visible"
              :ref="`crowdDetail${index}`"
              :showVisible="item.visible"
              :editDataValue="item.editData"
              :isAi="true"
              @tagsInit="tagsInit(item)"
              @nameChange="(e) => nameChange(e, index)"
            />
            <div
              v-if="!item.visible"
              class="empty"
              v-loading="!item.visible"
            ></div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="drawer-footer">
        <jd-button type="blue" @click="handleConfirm">确定</jd-button>
        <jd-button type="default" @click="handleClose">取消</jd-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
const globalCdn = "https://cdn-image.yucrm.cn/images/dyAssets";
import CustimerdetailNew from "@/views/manage/grouping/peopleFilter.vue";
export default {
  name: "EditGroup",
  components: {
    CustimerdetailNew,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tabList: {
      type: Array,
      default: () => [],
    },
    addable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globalCdn,
      activeTab: "",
      tabs: [],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    tabList: {
      handler(newVal) {
        if (newVal.length) {
          this.tabs = newVal.map((item, index) => ({
            ...item,
            name: item.name,
            value: item.name + index,
            visible: true,
          }));
          this.activeTab = this.tabs[0].value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    tagsInit(item) {
      this.$set(item, "visible", true);
    },
    handleTabsEdit(targetName, action) {
      console.log(targetName, action);
      if (action === "add") {
        if (this.tabs.length > 19) {
          this.$message.warning("每次编辑不可超出20个人群");
          return;
        }
        this.tabs.push({
          name: "未命名",
          value: "未命名" + `${this.tabs.length}`,
          editData: {},
          crowdNo: String(this.tabList.length + 1),
        });
        this.activeTab = "未命名" + `${this.tabs.length - 1}`;
      }
      if (action === "remove") {
        let tabs = this.tabs;
        let activeName = this.activeTab;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.value === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.value;
              }
            }
          });
        }

        this.activeTab = activeName;
        this.tabs = tabs.filter((tab) => tab.value !== targetName);
      }
    },
    nameChange(e, index) {
      if (e) {
        this.tabs[index].name = e;
      } else {
        this.tabs[index].name = "未命名";
      }
    },
    handleClose() {
      this.$emit("input", false);
      this.$emit("close");
    },
    handleConfirm() {
      const paramsList = [];
      this.tabs.forEach((item, index) => {
        const params = this.$refs[`crowdDetail${index}`][0].getData();
        paramsList.push(params);
      });
      Promise.all(paramsList).then((res) => {
        if (res.filter((item) => item).length == paramsList.length) {
          const result = this.tabs.map((item, index) => ({
            ...item,
            params: res[index],
          }));
          this.$emit("comfirm", result);
          this.$emit("input", false);
        }
      }).catch((err) => {
        this.$message.warning(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  display: flex;
  flex-direction: column;
  height: 100%;
  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 56px;
    border-bottom: 1px solid #f2f2f2;
    &-text {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
    &-close {
      img {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  }
  .drawer-content {
    flex: 1;
    overflow: hidden;
    padding: 20px 24px 0px;
    .edit-group-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      ::v-deep .el-tabs__header {
        margin-bottom: 16px;
      }
      ::v-deep .el-tabs__nav {
        margin-left: 0px !important;
      }
      ::v-deep .el-tabs__item {
        & + & {
          padding-left: 0px;
        }
        &.is-active {
          .el-icon-close {
            color: $theme-color;
            background-color: transparent;
          }
        }
      }
      ::v-deep .el-tabs__content {
        flex: 1;
        overflow: auto;
      }
      ::v-deep .el-tab-pane {
        height: 100%;
      }
      ::v-deep .el-tabs__new-tab {
        margin-bottom: 0px;
        margin-top: 0px;
        line-height: 15px;
        border: 1px solid #3159ff;
        color: #3159ff;
      }
      ::v-deep .el-tabs__nav-next {
        line-height: 22px;
      }
      ::v-deep .el-tabs__nav-prev {
        line-height: 22px;
      }
    }

    ::v-deep .visible {
      width: 100%;
      padding: 0px;
      .tabs-box {
        display: none;
      }
      .filter-content {
        height: 100%;
        overflow: hidden;
      }
      .search-form {
        margin-top: 0px;
      }
      .crowdBox {
        height: calc(100% - 48px);
      }
      .attr-rightbigbox {
        flex: 1;
      }
      .footer-save {
        display: none;
      }
    }
  }
  .drawer-footer {
    height: 62px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 15px 24px;
    border-top: 1px solid #f2f2f2;
  }
}
.empty {
  height: 100%;
  width: 100%;
}
</style>
